import { Dayjs } from 'dayjs';
import localDateTimeIso8601 from '@justpark/helpers/src/localDateTimeIso8601/localDateTimeIso8601';

const formatDate = (date: Dayjs, format = localDateTimeIso8601) =>
  date.format(format);

export default formatDate;
